function applyConfirmPurchaseUI() {
    var product_id = getUrlParameter('id');
    $('#checkout-progress').hide();
    console.log(product_id);
    if (product_id) {
      $("#cart_item_title").text('Confirm purchase');
      $(".title-wrapper-with-link").addClass('cart_title');
      $(".cart-items").addClass('cart_setep_final_table');
      $("#main-cart-items").addClass('product_cart_items');
      $("#main-cart-footer").addClass('container product_cart_footer');
      $(".underlined-link").hide();
      $(".tax-note").hide();
      $('#checkout-progress').show();

      var collection_url = sessionStorage.getItem("collection_url");
      // Ensure we don't bind multiple identical handlers if this runs more than once
      $('.btn-order-final').off('click.confirm-purchase').on('click.confirm-purchase', function(e) {
        e.preventDefault();
        window.location.href = collection_url;
      });
    }
}

$(document).ready(function(){
    applyConfirmPurchaseUI();
    $('.step').removeClass('active');
    $('.step').addClass('valid');
    $('.step-4').addClass('active');
    $('.step-4').removeClass('valid');
    $('#checkout-progress:before').css('background-color', '#fe857b');
    $('#checkout-progress').data('current-step', 4);
    $('#checkout-progress').addClass('step-4');
    $('.previouslink').css('display', 'none');
    $('.step-4 >.previouslink').css('display', 'block');
    $('.btn-prev').on('click', function() {
        window.location.href = collection_url;
    });
});

// Re-apply the Confirm purchase layout any time the cart markup is replaced via AJAX
document.addEventListener('cart:updated', function() {
    applyConfirmPurchaseUI();
});

// Extra safety: ensure the Confirm purchase layout is applied after all assets load
window.addEventListener('load', function() {
    applyConfirmPurchaseUI();
});

function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(window.location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}